import styled, { css } from 'styled-components';

import { CrossSvg, SearchSvg } from '../../../assets/icons';
import theme from '../../../assets/theme';
import { IconWrapper } from '../../_atoms/IconWrapper';

const WhiteSearchInput = ({
  value,
  onChange,
  placeholder,
  className,
  icon = <SearchSvg />,
  onPressEnter,
  autoFocus,
  disabled,
  label,
  style,
  onBlur,
  type = 'text',
}: {
  value?: string;
  onChange: (val: string) => void;
  placeholder?: string;
  label?: string;
  disabled?: boolean;
  icon?: React.ReactNode | null;
  className?: string;
  onPressEnter?: () => void;
  autoFocus?: boolean;
  style?: React.CSSProperties;
  onBlur?: () => void;
  type?: 'text' | 'number';
}) => {
  const handleKeyUp = (key: string) => {
    if (key === 'Enter') {
      onPressEnter && onPressEnter();
    }
  };
  return (
    <SearchInputContainer className={className}>
      {icon !== null && (
        <IconWrapper
          style={{
            position: 'absolute',
            left: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'default',
            zIndex: 1,
          }}
          className={className}
          height="20px"
          width="20px"
          color="#5B5B5A"
        >
          {icon}
        </IconWrapper>
      )}
      <div
        style={{
          ...(style || {}),
          position: 'relative',
          display: 'flex',
          flexWrap: 'wrap',
          width: '100%',
          height: 42,
        }}
      >
        {label && (
          <span
            style={{
              color: '#a5a5a5',
              fontWeight: 'normal',
              marginBottom: '4px',
              fontSize: '12px',
            }}
          >
            {label}
          </span>
        )}
        <SearchInputComp
          type={type}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          className={className}
          onChange={e => onChange(e.target.value)}
          onKeyUp={e => handleKeyUp(e.key)}
          autoFocus={autoFocus}
          onBlur={onBlur}
          $hideIcon={icon === null}
        />
        {value && value.length > 0 && (
          <IconWrapper
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
            }}
            onClick={() => onChange('')}
            height="15px"
            width="15px"
            color="#5B5B5A"
          >
            <CrossSvg />
          </IconWrapper>
        )}
      </div>
    </SearchInputContainer>
  );
};

const SearchInputContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
`;

const SearchInputComp = styled.input<{ $hideIcon?: boolean }>`
  border-radius: 5px;
  background: white;
  outline: none;
  border: none;
  height: 100%;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 40px;
  padding-right: 30px;
  font-weight: bold;
  color: #5b5b5a;
  font-size: 16px; // Prevent zooming in on mobile
  box-shadow: ${theme.effects.floatingCreatorElementShadow}
    ${({ $hideIcon }) =>
      $hideIcon === true &&
      css`
        padding-left: 10px;
      `};
`;

export default WhiteSearchInput;
